var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Stack, Icon } from '@noom/wax-component-library';
import { FormattedMessage } from 'react-intl';
import { toHumanString } from '../../../../helpers/toHumanString';
import Skeleton from '../../../../core/components/Skeleton';
import customizableComponent from '../../../../core/hocs/customization';
import { backgroundImage as communityCoverPlaceholder } from '../../../../icons/CommunityCoverPicture';
import { CommunityName, Container, Content, Count, Cover, Description } from './styles';
const UICommunityCard = (_a) => {
    var { avatarFileUrl, communityId, communityCategories, membersCount, description, onClick, isOfficial, isPublic, name, loading, onClickJoin, isJoining, isJoined, showMemberCount } = _a, props = __rest(_a, ["avatarFileUrl", "communityId", "communityCategories", "membersCount", "description", "onClick", "isOfficial", "isPublic", "name", "loading", "onClickJoin", "isJoining", "isJoined", "showMemberCount"]);
    const handleClick = () => onClick(communityId);
    const handleButtonClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onClickJoin();
    };
    return (React.createElement(Container, Object.assign({ onClick: handleClick }, props),
        React.createElement(Cover, { backgroundImage: avatarFileUrl !== null && avatarFileUrl !== void 0 ? avatarFileUrl : communityCoverPlaceholder }),
        React.createElement(Content, null,
            React.createElement(Stack, { spacing: 3 },
                loading ? (React.createElement(Skeleton, { count: 1, style: { fontSize: 14 } })) : (React.createElement(CommunityName, { isOfficial: isOfficial, isPublic: isPublic, isTitle: true, name: name, truncate: 2 })),
                loading && React.createElement(Skeleton, { count: 2, style: { fontSize: 8 } }),
                !loading && React.createElement(Description, { title: description }, description),
                !loading && showMemberCount && (React.createElement(Count, null,
                    toHumanString(membersCount),
                    ' ',
                    React.createElement(FormattedMessage, { id: "plural.member", values: { amount: membersCount } }))),
                React.createElement(Button, { width: "100%", size: "lg", colorScheme: "secondary", isLoading: loading || isJoining, isDisabled: isJoined, onClick: handleButtonClick }, isJoined ? React.createElement(Icon, { icon: "check" }) : React.createElement(FormattedMessage, { id: "community.join" }))))));
};
UICommunityCard.defaultProps = {
    communityCategories: [],
    onClick: () => { },
    isOfficial: false,
    isPublic: false,
    name: '',
    loading: false,
    showMemberCount: false,
};
UICommunityCard.propTypes = {
    avatarFileUrl: PropTypes.string,
    communityId: PropTypes.string,
    communityCategories: PropTypes.arrayOf(PropTypes.shape({
        categoryId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    })),
    membersCount: PropTypes.number,
    description: PropTypes.string,
    isOfficial: PropTypes.bool,
    isPublic: PropTypes.bool,
    name: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    showMemberCount: PropTypes.bool,
    onClickJoin: PropTypes.func,
    isJoining: PropTypes.bool,
    isJoined: PropTypes.bool,
};
export default customizableComponent('UICommunityCard', UICommunityCard);
//# sourceMappingURL=UICommunityCard.js.map